export async function clearIndexKeysFromCache() {
  console.log('clearIndexKeysFromCache');
  let keys = await caches.keys();
  await Promise.all(keys.map(async key => await caches.delete(key)));
}

export async function unregisterServiceWorker() {
  console.log('unregisterServiceWorker');
  let registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map(async registration => await registration.unregister()));
}
